export abstract class ClassTransformService {
	abstract plainToClass<T, V>(type: new (...args: any[]) => T, plain: V): T;
}
